<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
    >
        <path
            d="M13 7L7.70711 1.70711C7.37377 1.37377 7.20711 1.20711 7 1.20711C6.79289 1.20711 6.62623 1.37377 6.29289 1.70711L1 7"
            stroke="#ED1C24"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    name: "ArrowUp",
};
</script>
